import { DisciplineDistributionItem } from './dashboardApi';

export interface DisciplinesDataset {
  labels: string[];
  values: number[];
}

export const buildDisciplinesDataset = (
  disciplines: DisciplineDistributionItem[]
): DisciplinesDataset => {
  if (!disciplines?.length) {
    return { labels: [], values: [] };
  }

  return {
    labels: disciplines.map((discipline) => discipline.name || 'Unknown'),
    values: disciplines.map((discipline) => discipline.message_count ?? 0),
  };
};

